import React, { useEffect, useState } from "react";
import { drawsFrom, numbersOf, dateOf, prettyGame } from "../utils/draws";

/**
 * The most recent published result for a game, shown as lottery balls.
 *
 * This is the reason most visitors arrive, so it sits above everything else on
 * the home page and renders its own loading and failure states rather than
 * leaving a blank card.
 */

function normaliseDraw(draw) {
  if (!draw) return null;
  const numbers = numbersOf(draw);
  return numbers.length ? { numbers, date: dateOf(draw) } : null;
}

function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

const LatestDraw = ({ game = "Daily3" }) => {
  const [state, setState] = useState({ status: "loading", draw: null });

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(`/api/draw?game=${game}`);
        if (!res.ok) throw new Error(`Draw API returned ${res.status}`);
        const body = await res.json();
        const draw = normaliseDraw(drawsFrom(body)[0]);
        if (!cancelled) setState({ status: draw ? "ready" : "empty", draw });
      } catch {
        if (!cancelled) setState({ status: "error", draw: null });
      }
    })();

    return () => { cancelled = true; };
  }, [game]);

  const drawnOn = formatDate(state.draw?.date);

  return (
    <article className="card">
      <p className="card-label">{prettyGame(game)}</p>

      {state.status === "loading" && <p className="chart-sub">Loading latest result…</p>}
      {state.status === "error" && <p className="error">Results unavailable right now.</p>}
      {state.status === "empty" && <p className="chart-sub">No published result yet.</p>}

      {state.status === "ready" && (
        <>
          <div className="balls">
            {state.draw.numbers.map((number, index) => (
              // Position matters and digits repeat, so the index is the identity here.
              // eslint-disable-next-line react/no-array-index-key
              <span className="ball" key={`${number}-${index}`}>{number}</span>
            ))}
          </div>
          <p className="chart-sub">
            {drawnOn ? `Drawn ${drawnOn}` : "Most recent published draw"} · official result
          </p>
        </>
      )}
    </article>
  );
};

export default LatestDraw;
